/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { useTranslation } from '../../../hooks';

type PropsFilterSelectPatient = {
  name: string,
  config: {
    component: any;
    name: any;
  }
}

export function FilterSelectPatient({
  name,
  config
}: PropsFilterSelectPatient) {
  const { t } = useTranslation();
  return (
    React.createElement(config.component, {
      name: name,
      label: `${t(config.name)}`,
      placeholder: t('Enter a patient'),
      isModal: true,
      isNotAddNewPatient: true
    })
  );
}

export default FilterSelectPatient;
